import { format } from "path";
import { nextTick } from "process";
const sensorsMixin = {
    beforeRouteEnter(to,from, next) {
        next(vm=>{
            const visitReferrerList = {
                home: '首页',
                goods_list: '站点_实物商品',
                course_list: '站点_培训商品',
                study: '学习'
            }
            let visitReferrer = '';
            if(to.query.visit_referrer) {
                visitReferrer = visitReferrerList[to.query.visit_referrer] || to.query.visit_referrer
            }

            vm.fromName = from.meta.title || visitReferrer;
            vm.newTime = new Date().getTime()
        })
    },
    beforeRouteUpdate(to,from,next) {
        this.leavePage();
        next();
    },
    data() {
        return {
            newTime: '',
            fromName: '',
        }
    },
    methods: {
        leavePage() {
            const currentDate = new Date().getTime() - this.newTime;
            const wechatLog = this.isWechat? {
                percentage_rate: 0,
                is_promoter: false,
            } : {}
            // this.onTrack( this.isWechat? 'commodity_share_page_view':'commodity_details_view',{
            this.onTrack('commodity_details_view',{
                visit_referrer: this.fromName,
                commodity_view_duration: currentDate / 1000,
                share_activity_source:this.$route.query.share_activity_source || '',
                ...wechatLog,
            })
        },
        getPublicLogParams(obj) {
            const {commodity_id, commodity_name, 
                aff_institution_name, aff_institution_id, original_price, 
                current_price, goodsKinds ,commodity_firstcate, commodity_secondcate, commodity_thirdcate } = obj;
            return {
                commodity_id,
                commodity_type: goodsKinds == 3 ? '实物商品':goodsKinds == 2?'分销商品':'培训商品',
                aff_institution_id,
                aff_institution_name,
                commodity_firstcate,
                commodity_secondcate,
                commodity_thirdcate,
                commodity_name,
                original_price,
                current_price,
            }
        },
        onTrack(name, params, status = true) {
            const detailObj = this.getLogParams();
            
            const defaultParams = status && Object.keys(detailObj).length? this.getPublicLogParams(detailObj) :{};
            const obj = {
                ...defaultParams,
                ...params,
            }
            console.log(obj)
            this.$sensors.track(name, obj)
        }
    },
}
export {
    sensorsMixin
}